import React, { forwardRef } from "react";

// 결과보고서 - 문항별 응답 페이지 (영역 1개씩 = 한 페이지)
// 언어 이해 및 표현(14) / 말 및 문해(16)를 각각 별도 페이지로 렌더.
// A4(794x1123px) 안에 여유있게 들어가도록 폰트/간격을 구성.

const A4_STYLE = {
  width: "794px",
  minHeight: "1123px",
  backgroundColor: "#ffffff",
  boxSizing: "border-box",
  fontFamily: "'Noto Sans KR', sans-serif",
  padding: "46px 50px",
  color: "#1a1a1a",
};

const answerStyle = (label) => {
  const map = {
    예: { color: "#2e9e4f", bg: "#eaf7ee" },
    아니요: { color: "#e0352b", bg: "#fcebe9" },
    모르겠음: { color: "#5b6b9c", bg: "#eef0f6" },
    미응답: { color: "#999999", bg: "#f5f5f5" },
  };
  const c = map[label] || map["미응답"];
  return {
    color: c.color,
    backgroundColor: c.bg,
    fontWeight: 700,
    fontSize: "14px",
    textAlign: "center",
    border: "1px solid #d9dce3",
    padding: "9px 4px",
    whiteSpace: "nowrap",
    width: "84px",
  };
};

const numCell = {
  border: "1px solid #d9dce3",
  padding: "9px 4px",
  fontSize: "14px",
  textAlign: "center",
  width: "48px",
  color: "#555555",
};
const qCell = {
  border: "1px solid #d9dce3",
  padding: "9px 12px",
  fontSize: "14px",
  textAlign: "left",
  lineHeight: 1.4,
};
const sectionHead = {
  backgroundColor: "#003366",
  color: "#ffffff",
  fontSize: "16px",
  fontWeight: 700,
  padding: "10px 14px",
  marginTop: "20px",
  borderRadius: "4px",
};
const colHead = {
  backgroundColor: "#eef0f6",
  border: "1px solid #d9dce3",
  padding: "8px",
  fontSize: "13px",
  fontWeight: 600,
  textAlign: "center",
};

const SLEReportPage2 = forwardRef((props, ref) => {
  const { sectionTitle, rows = [], clientName, pageLabel } = props;

  return (
    <div ref={ref} style={A4_STYLE}>
      <div
        style={{
          backgroundColor: "#003366",
          color: "#ffffff",
          textAlign: "center",
          padding: "16px",
          borderRadius: "6px",
          fontSize: "21px",
          fontWeight: 700,
        }}
      >
        문항별 응답 내용
        {clientName ? ` — ${clientName}` : ""}
        {pageLabel ? `  (${pageLabel})` : ""}
      </div>

      <div
        style={{
          marginTop: "12px",
          fontSize: "13px",
          color: "#666666",
          lineHeight: 1.6,
        }}
      >
        각 문항에 대해 평가자가 표시한 응답입니다 (예 / 아니요 / 모르겠음).
      </div>

      <div style={sectionHead}>{sectionTitle}</div>
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "8px",
          tableLayout: "fixed",
        }}
      >
        <thead>
          <tr>
            <th style={{ ...colHead, width: "48px" }}>번호</th>
            <th style={colHead}>문항</th>
            <th style={{ ...colHead, width: "84px" }}>응답</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((q) => (
            <tr key={q.id}>
              <td style={numCell}>{q.id}</td>
              <td style={qCell}>{q.question}</td>
              <td style={answerStyle(q.answerLabel)}>{q.answerLabel}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
});

export default SLEReportPage2;
